import { useTranslation } from 'react-i18next';
import CardGame from '../Card/CardGame';
import TitleSection from '../../atom/Title/TitleSection';
import { MotionComponent } from '../../atom/MotionComponent';
import useGameStore from '@/context/store/useGameStore.store';

const GamepopularComponent2 = ({ slideMode, showTitle }) => {
	const { t } = useTranslation();
	const { popularGameData } = useGameStore((state) => ({
		popularGameData: state.popularGameData
	}));

	return (
		<>
			<MotionComponent slideMode={slideMode}>
				<div className="flex w-full flex-col mb-section">
					{showTitle && <TitleSection title={t('text.popularGame')} />}
					<div className="flex gap-2 overflow-x-auto overflow-hidden scrollbar-none">
						{popularGameData?.map((item, index) => (
							<div className="w-full h-full" key={index}>
								<div className="w-28">
									<CardGame game={item} />
								</div>
							</div>
						))}
					</div>
				</div>
			</MotionComponent>
		</>
	);
};

export default GamepopularComponent2;
